<i18n src="@/locales/models/harvested_batch.yml" lang="yaml"></i18n>
<i18n src="@/locales/models/harvested_package.yml" lang="yaml"></i18n>
<i18n
  src="@/locales/views/packing_house/process/manage_harvested_batch/show_harvested_batch.yml"
  lang="yaml"
></i18n>

<template>
  <div class="">
    <go-back-link
      :text="$t('labels.go_back_link')"
      name="ph_process_harvested_batches_list"
      :params="{
        packing_house_id: this.packing_house_id,
        packing_house_process_id: packing_house_process_id,
      }"
    />
    <bread-crumbs
      :labels="[
        module_name,
        packing_house_process.name,
        $t('labels.harvested_batches_title'),
      ]"
    ></bread-crumbs>
    <alert-danger :errors_data="std_err" />
    <div class="mt-8">
      <div class="panel" v-if="harvested_batch">
        <div class="panel-header">
          <h3 class="panel-header-title">
            {{ $t("labels.title") }}
          </h3>
        </div>

        <div class="panel-body">
          <div
            class="space-y-8 divide-y divide-gray-200"
            v-if="harvested_batch"
          >
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.batch_code") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.batch_code }}
                </dd>
              </div>

              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.registered_at") }}
                </dt>
                <dd class="content-data">
                  {{ dateFormatter(harvested_batch.registered_at) }}
                </dd>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.producer") }}
                </dt>
                <dd class="content-data">
                  {{ producerLabel(harvested_batch) }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.crop_field") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.crop_field?.name }}
                </dd>
              </div>
            </div>

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-6">
              <template
                v-for="(
                  harvested_package, idx
                ) in harvested_batch.harvested_packages"
                :key="idx"
              >
                <div class="sm:col-span-3">
                  <dt class="label-data">
                    {{ $t("model.harvested_package.crop_har_package") }}
                  </dt>
                  <dd class="content-data">
                    {{ harvested_package.crop_har_package.name }}
                  </dd>
                </div>

                <div class="sm:col-span-3">
                  <dt class="label-data">
                    {{ $t("model.harvested_package.number") }}
                  </dt>
                  <dd class="content-data">
                    {{ harvested_package.number }}
                  </dd>
                </div>
              </template>
            </div>

            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.total_weight") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.total_weight }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.discarded_weight") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.discarded_weight }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.ok_weight") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.ok_weight }}
                </dd>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.crop_type") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.crop_type.name }}
                </dd>
              </div>
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.crop_variety") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.crop_variety.name }}
                </dd>
              </div>
            </div>
            <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 pt-6">
              <div class="sm:col-span-3">
                <dt class="label-data">
                  {{ $t("model.harvested_batch.agro_exporter") }}
                </dt>
                <dd class="content-data">
                  {{ harvested_batch.agro_exporter.name }}
                </dd>
              </div>
            </div>
          </div>
        </div>
        <div class="panel-footer">
          <div class="panel-footer-actions">
            <destroy-button
              v-if="!proc_button_destroy"
              :disabled_button="proc_button_destroy"
              @destroyEvent="destroyHarvestedBatch()"
              :label="$t('labels.destroy_button_label')"
              :title="$t('labels.destroy_button_title')"
              :message="$t('labels.destroy_button_message')"
              :label_confirm="$t('labels.destroy_button_label_confirm')"
            />
            <destroy-button-processing
              v-else
              :label="$t('labels.destroy_button_label')"
            />
            <span class="space-actions"></span>
            <edit-button @click.prevent="goToEditHarvestedBatch()" :label="$t('labels.edit_button')" />
          </div>
        </div>
      </div>
      <loading-message v-else />
    </div>
  </div>
</template>

<script>
import Requester from "@/views/packing_house/requesters/process/harvested_batches/manage_harvested_batch.js";

export default {
  name: "ShowHarvestedBatch",
  data() {
    return {
      packing_house_process: {},
      harvested_batch: null,
      proc_button_destroy: false
    };
  },
  props: {
    packing_house_id: {
      required: true,
    },
    packing_house_process_id: {
      required: true,
    },
    harvested_batch_id: {
      required: true,
    },
  },
  created() {
    this.checkIfAuthenticated().then(() => {
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          packing_house_id: this.packing_house_id,
        },
      }).then(() => {
        this.fetchPackingHouseProcess();
        this.fetchHarvestedBatch();
      });
    });
  },
  methods: {
    fetchPackingHouseProcess: async function () {
      const response = await Requester.fetchPackingHouseProcess(
        this.packing_house_process_id
      );
      this.packing_house_process = response.data;
    },
    fetchHarvestedBatch: async function () {
      const response = await Requester.fetchHarvestedBatch(
        this.harvested_batch_id
      );
      this.harvested_batch = response.data;
    },
    goToEditHarvestedBatch: function () {
      this.$router.push({
        name: "ph_process_harvested_batches_edit",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
          harvested_batch_id: this.harvested_batch_id,
        },
      });
    },
    goToListHarvestedBatch: function () {
      this.$router.push({
        name: "ph_process_harvested_batches_list",
        params: {
          packing_house_id: this.packing_house_id,
          packing_house_process_id: this.packing_house_process_id,
        },
      });
    },
    producerLabel: function (harvested_batch) {
      if (harvested_batch.producer && harvested_batch.organization) {
        return `${harvested_batch.producer.name} (${harvested_batch.organization.name})`;
      } else if (harvested_batch.organization) {
        return harvested_batch.organization.name;
      } else if (harvested_batch.producer) {
        return harvested_batch.producer.name;
      }
    },
    destroyHarvestedBatch: async function () {
      this.proc_button_destroy = true;
      try {
        const response = await Requester.destroy(this.harvested_batch_id);
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.goToListHarvestedBatch();
      } catch (error) {
        if (error.response.status == 422) {
          this.loadStandardErrorMessages({
            title: error.response.data.error_title,
            messages: error.response.data.error_messages,
            fields: error.response.data.error_fields,
          });
        }
      }
      this.proc_button_destroy = false;
    },
  },
};
</script>
